import { useLocation } from 'react-router-dom';
import ReportHeader from './components/ReportHeader';
import AdminInfo from './components/AdminInfo';
import Offenses from './components/Offenses';
import Arrestees from './components/Arrestees';
import Victims from './components/Victims';
import Properties from './components/Properties';
import Vehicles from './components/Vehicles';
import Summary from './components/Summary';
import styled from 'styled-components';
import type { CombinedReportType } from '../../types/CombinedReport';

const Container = styled.div`  
    max-width: 8.5in;  

    @media print {
        body {
            -webkit-print-color-adjust: exact; /* Chrome, Safari */
            color-adjust: exact; /* Firefox */
        }

        /* Hide default headers and footers */
        @page {
            margin: 1cm; /* Adjust as needed */
        }
    }
`;

const BackLink = styled.a`    
    @media print {    
        display: none !important;    
    }    
`;

interface ReportState {
    year: string;
    caseNumber: string;
    reportData: CombinedReportType;
}
const Report = () => {
    const location = useLocation();
    const { year, caseNumber, reportData }: ReportState = location.state || {};

    return (
        <Container>
            <BackLink href="/ReportSearch">Back</BackLink>
            <ReportHeader caseNumber={year + caseNumber} />
            <AdminInfo administrativeInformation={reportData.administrativeInformation} />
            <Offenses offenses={reportData.offenses} />
            <Arrestees
                arrestees={reportData.arrestees}
                offenses={reportData.offenses}
                relatedOffenses={reportData.relatedOffenses}
            />
            <Victims victims={reportData.victims} />
            <Vehicles vehicles={reportData.vehicles} />
            <Properties properties={reportData.properties} />
            <Summary summary={reportData.summary} />
        </Container>
    );
};

export default Report;
